import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import ProgramRequestModal from '../../shared/Modals/ProgramRequestModal';
import ModalBlock from '../../shared/ModalBlock/ModalBlock';
import OfflineGroupCard from '../../shared/Cards/OfflineGroupCard';
import { parseDate } from '../../helpers/lib';

import sectionStyles, {
  createTitleColorTheme,
} from '../../shared/Section/styles';
function OfflineGroupsContent({
  program,
  courseName,
  type,
  title,
  groups = [],
  requestLeadData,
  ymEvents = {},
  myTargetEvents = {},
  isPrecourse,
}) {
  const [isRequestOpen, setIsRequestOpen] = useState(false);
  const [currentGroup, setCurrentGroup] = useState(null);
  const [first, second] = groups;
  useEffect(() => {
    setIsRequestOpen(!!currentGroup);
  }, [currentGroup]);

  return (
    <Box sx={{ mt: { xs: 4, lg: 5 } }}>
      {title && (
        <Typography
          variant="desktopH2"
          sx={{
            ...sectionStyles.title,
            ...createTitleColorTheme('lightPurple'),
          }}
        >
          {Array.isArray(title)
            ? title.map((item) => <Typography key={item}>{item}</Typography>)
            : title}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 2, md: 6 },
        }}
      >
        {[first, second].map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            {item && (
              <OfflineGroupCard
                {...item}
                isPrecourse={isPrecourse}
                courseName={courseName}
                clickHandler={() =>
                  setCurrentGroup({
                    ...item,
                    ymClickEventType: ymEvents[index].groupsFormOpen,
                    ymSubmitEventType: ymEvents[index].groupsFormSubmit,
                  })
                }
              />
            )}
          </Grid>
        ))}
      </Box>
      <ModalBlock
        isOpen={isRequestOpen}
        handleClose={() => setCurrentGroup(null)}
        ymClickEventType={currentGroup?.ymClickEventType}
        myTargetEventType={currentGroup?.myTargetClickEventType}
      >
        {!!currentGroup && (
          <ProgramRequestModal
            extraLeadData={requestLeadData}
            startDate={
              currentGroup.startDate && parseDate(currentGroup.startDate)
            }
            endDate={currentGroup.endDate && parseDate(currentGroup.endDate)}
            date={currentGroup?.startDate}
            formData={{ title: program, subtitle: type }}
            ymSubmitEventTypes={[currentGroup?.ymSubmitEventType]}
            myTargetSubmitEventTypes={[currentGroup?.myTargetSubmitEventType]}
          />
        )}
      </ModalBlock>
    </Box>
  );
}

export default OfflineGroupsContent;
